import { render, staticRenderFns } from "./OriginatorRules.vue?vue&type=template&id=22c012b4&"
import script from "./OriginatorRules.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports